import type { Light, TreasuryReport, TreasuryRow } from '@odd/domain';

export const treasuryNumber = (value: number) => value.toLocaleString('es-ES', { maximumFractionDigits: 20 });
const currency = new Intl.NumberFormat('es-ES', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
  useGrouping: 'always',
});
export const treasuryEuro = (value: number) => currency.format(value);
const months = (value: number) => `${treasuryNumber(value)} ${Math.abs(value) === 1 ? 'mes' : 'meses'}`;

/** Los mismos límites inclusivos y textos se usan en pantalla y en el informe. */
export function treasuryThresholdRanges(t: TreasuryReport['thresholds']) {
  return {
    coverage: [
      `${months(t.F1.red)} o menos`,
      `Más de ${treasuryNumber(t.F1.red)} y hasta ${months(t.F1.amber)}`,
      `Más de ${months(t.F1.amber)}`,
    ],
    debt: [
      `${treasuryNumber(t.F2.red)} % o más`,
      `Desde ${treasuryNumber(t.F2.amber)} % y menos de ${treasuryNumber(t.F2.red)} %`,
      `Menos de ${treasuryNumber(t.F2.amber)} %`,
    ],
  };
}

const lightLabels: Record<Light, string> = { rojo: 'Rojo', ambar: 'Ámbar', verde: 'Verde' };
export function treasuryMetric(row: TreasuryRow, key: 'f1' | 'f2') {
  const value = row[key];
  const light = row[key === 'f1' ? 'f1Light' : 'f2Light'];
  return {
    value: value == null ? '—' : key === 'f1' ? months(value) : `${treasuryNumber(value)} %`,
    label:
      value == null
        ? key === 'f2' && row.impagados <= 0 && row.gastos12m > 0
          ? 'Sin impagados'
          : 'Sin base'
        : light
          ? lightLabels[light]
          : 'Sin estado',
    light: value == null ? null : light,
  };
}
